/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown> }} Progress_Extra_Wrapped_MonthInputs */

const en_us2_progress_extra_wrapped_month = /** @type {(inputs: Progress_Extra_Wrapped_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.month} in review`)
};

const pt_br2_progress_extra_wrapped_month = /** @type {(inputs: Progress_Extra_Wrapped_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retrospectiva de ${i?.month}`)
};

const es_419_progress_extra_wrapped_month = /** @type {(inputs: Progress_Extra_Wrapped_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resumen de ${i?.month}`)
};

const pt_pt2_progress_extra_wrapped_month = /** @type {(inputs: Progress_Extra_Wrapped_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retrospetiva de ${i?.month}`)
};

const fr_fr2_progress_extra_wrapped_month = /** @type {(inputs: Progress_Extra_Wrapped_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.month} en bref`)
};

const de_de2_progress_extra_wrapped_month = /** @type {(inputs: Progress_Extra_Wrapped_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rückblick ${i?.month}`)
};

const it_it2_progress_extra_wrapped_month = /** @type {(inputs: Progress_Extra_Wrapped_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Riepilogo di ${i?.month}`)
};

/**
* | output |
* | --- |
* | "{month} in review" |
*
* @param {Progress_Extra_Wrapped_MonthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_wrapped_month = /** @type {((inputs: Progress_Extra_Wrapped_MonthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Wrapped_MonthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_wrapped_month(inputs)
	if (locale === "es-419") return es_419_progress_extra_wrapped_month(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_wrapped_month(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_wrapped_month(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_wrapped_month(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_wrapped_month(inputs)
	return en_us2_progress_extra_wrapped_month(inputs)
});
export { progress_extra_wrapped_month as "progress-extra.wrapped_month" }